import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    search: {
        url: `${customerApi}/api/customers/search`,
        type: 'POST',
    },
    detail: {
        url: `${customerApi}/api/customers/{id}/detail`,
        type: 'GET',
    },
    syncStatus: {
        url: `${customerApi}/api/customers/sync/status`,
        type: 'GET',
    },
    manualSync: {
        url: `${customerApi}/api/customers/sync`,
        type: 'POST',
    },
    // 数据导出
    exportTaskId: {
        url: `${customerApi}/api/customers/export`,
        type: 'POST',
    },
    // 定制-名创数据导出
    exportMCTaskId: {
        url: `${customerApi}/api/oem_miniso/customers/export`,
        type: 'POST',
    },
    // 定制-toptoy数据导出（与名创相同）
    exportTopToyTaskId: {
        url: `${customerApi}/api/oem_miniso/customers/export`,
        type: 'POST',
    },
}
